import { useEffect } from "react";

import { useAppSelector } from "../redux/hooks";

declare const window: any;

export const useSetAppcues = () => {
  const { user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (user && window.Appcues) {
      window.Appcues.identify(user.userDetails.userId, {
        name: user.userDetails.displayName,
        email: user.userDetails.primaryEmailAddress,
      });
    }
  }, [user]);
};
